import { useEffect, useState } from 'react';

export const useLoadingTimeSplit = (active: boolean, delayInMillis = 300) => {
  const [isDelayPassed, setIsDelayPassed] = useState(false);

  useEffect(() => {
    if (!active) {
      setIsDelayPassed(false);
      return;
    }

    const timer = setTimeout(() => {
      setIsDelayPassed(true);
    }, delayInMillis);

    return () => {
      clearTimeout(timer);
      setIsDelayPassed(false);
    };
  }, [active, delayInMillis]);

  return {
    isLoadingBeforeDelay: active && !isDelayPassed,
    isLoadingAfterDelay: active && isDelayPassed,
  };
};
